import React, { Fragment } from 'react';
import { ICatalogSnapshot } from '@app/common';
import { Button, CardButtonActionMode, Panel } from '@app/components';
import { CatalogSnapshotCard } from './CatalogSnapshotCard';
import { triptychSelectors } from '@app/store';
import { useAppSelector } from '@app/store/hooks';
import styled from '@2pulse/responsive';
import { normalize } from '@app/helpers/normalize';

interface CatalogSnapshotShowProps {
  catalogSnapshot?: Partial<ICatalogSnapshot>;
  isLoading?: boolean;
  toggle: (mode: CardButtonActionMode) => void;
}

const PreviewContainer = styled.View({
  paddingTop: normalize(55),
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
});

export const CatalogSnapshotShow = ({ catalogSnapshot, isLoading, toggle }: CatalogSnapshotShowProps) => {
  const { url } = useAppSelector<{ url?: string }>(triptychSelectors.selectData);

  return (
    <Fragment>

      <CatalogSnapshotCard
        catalogSnapshot={catalogSnapshot}
        toggle={toggle} />

      <Panel.Content>

        <PreviewContainer>
          <Panel.Header>
            <Button
              title="Voir dans un nouvel onglet"
              onPress={() => window.open(url, '_blank')}
              disabled={!url} />
          </Panel.Header>

          {isLoading ? <p>Chargement...</p> : <iframe src={url} width="100%" height="100%" />}
        </PreviewContainer>

      </Panel.Content>
    </Fragment>
  );
};
